import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { ReactComponent as ChartIcon } from '../../../assets/Icons/adornments/BarChart.svg';
import ImageToggle from '../../../components/Buttons/ImageToggle';
import { TableData, TableHeader } from '../../../components/Table/DataTable';
import FrequencyVsAlphaConsensus from './ResultPlots/FrequencyVsAlphaConsensus';

import FrequencyVsAlphaIndividual from './ResultPlots/FrequencyVsAlphaIndividual';
import HorizontalNumberSlider from '../../../components/Data/HorizontalNumberSlider';
import { Skeleton } from '@mui/material';

const normalPredictionTabs = ['Prediction Scores'];
const conformalPredictionTabs = ['Frequency Vs. Alpha (Consensus)', 'Frequency Vs. Alpha (Individual)'];

export default function ResultComparison({
    data,
    isLoading,
    threshold,
    setThreshold,
    headers,
}: {
    data: TableData[],
    isLoading: boolean,
    threshold: number,
    setThreshold: Dispatch<SetStateAction<number>>,
    headers: TableHeader[],
}) {
    const [ selectedIndex, setSelectedIndex ] = useState(0);
    const [ tabs, setTabs ] = useState<string[]>([]);

    useEffect(() => {
        if (threshold !== null) {
            setTabs(conformalPredictionTabs)
        } else {
            setTabs(normalPredictionTabs)
        }
    }, [threshold]);


    return (
        <>
        {isLoading ? (
            <div className="w-full flex flex-col justify-start items-stretch bg-white rounded-2xl border border-outline">
                <div className='p-6'>
                    <div className='w-[300px] h-[30px]'><Skeleton variant='rounded' width='100%' height='100%'/></div>
                </div>
                <div className='p-6'>
                    <div className='w-full h-[600px]'><Skeleton variant='rounded' width='100%' height='100%'/></div>
                </div>
            </div>
        ) : data.length > 0 ? (
            <div className="w-full flex flex-col justify-start items-stretch bg-white rounded-2xl border border-outline">
                <div className="w-full flex justify-between items-center gap-8 p-6">
                    <div className="flex gap-2">
                        <div className="w-[20px] text-disable"><ChartIcon /></div>
                        <p className="text-default font-semibold text-[20px]">{`${tabs[selectedIndex]} ${threshold !== null && '- ' + threshold}`}</p>
                    </div>
                    <div className='flex gap-8'>
                        {threshold !== null && (
                            <HorizontalNumberSlider 
                                label="Alpha Threshold"
                                threshold={threshold}
                                setThreshold={setThreshold}
                                hasBorderAndPadding={false}
                            />
                        )}

                        {tabs.length > 1 && (
                            <ImageToggle 
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                totalIndices={tabs.length}
                            />
                        )}
                    </div>
                    
                </div>

                {threshold !== null ? (
                    <>
                    {tabs[selectedIndex] === 'Frequency Vs. Alpha (Consensus)' ? (
                        <FrequencyVsAlphaConsensus 
                            data={data}
                            threshold={threshold}
                            headers={headers}
                        />
                    ) : tabs[selectedIndex] === 'Frequency Vs. Alpha (Individual)' ? (
                        <FrequencyVsAlphaIndividual 
                            data={data}
                            threshold={threshold}
                            headers={headers}
                        />
                    ) : (
                        <></>
                    )}
                    </>
                ) : (
                    <></>
                )}
            </div>
        ) : (
            <></>
        )}
        </>
    )
}